import PropTypes from 'prop-types';
import React from 'react';
import CardGrid, { FooterText, formatCount } from './common/grid/CardGrid';
import FitGrid from './common/grid/FitGrid';
import CardRow from './common/grid/CardRow';
import CardGridBody from './common/grid/CardGridBody';
import AuthorCard from './AuthorCard';
import { diffAuthorAgainstPublic, mergeAuthor } from '../common/ItemTools';
import useGridLayout from '../hooks/useGridLayout';

export default function AuthorCardGrid(props) {
  const {
    currentPage,
    authorActions,
    listActions,
  } = props;

  const { handleNextPage, handlePreviousPage } = listActions;

  const {
    pagesCount, pageNumber, authors, authorCount,
  } = currentPage || {};

  const countLabel = formatCount(authorCount, 'author', 'authors');

  const { arrangement, rowCap } = useGridLayout();
  const lgSpan = Math.max(1, Math.round(12 / arrangement.cols));
  const cardDirection = arrangement.cols === 1 ? 'column' : 'row';

  const merged = (authors || []).map((author) => {
    const card = mergeAuthor(author);
    if (card) card.shareDiff = diffAuthorAgainstPublic(author);
    return card;
  });

  const card = (author) => (
    <AuthorCard
      author={author}
      {...authorActions}
    />
  );

  return (
    <CardGrid
      hasContent={merged.length > 0}
      pageNumber={pageNumber}
      pagesCount={pagesCount}
      onNextPage={handleNextPage}
      onPreviousPage={handlePreviousPage}
      counter={countLabel ? <FooterText>{countLabel}</FooterText> : null}
    >
      <FitGrid>
        {merged.length <= 3 ? (
          <CardRow items={merged} direction={cardDirection} renderCard={card} />
        ) : (
          <CardGridBody items={merged} renderCard={card} lgSpan={lgSpan} rowCap={rowCap} />
        )}
      </FitGrid>
    </CardGrid>
  );
}

AuthorCardGrid.propTypes = {
  currentPage: PropTypes.object.isRequired,
  authorActions: PropTypes.object.isRequired,
  listActions: PropTypes.object.isRequired,
};
